import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { TextField, CheckboxWithLabel } from "formik-material-ui";
import { Debug } from "../../../Molecules/Forms/Debug";
import * as Yup from "yup";
import { Grid, Button, Create, FormControlLabel, makeStyles, SubmitButton } from "../../..";
var useStyles = makeStyles(function (theme) {
  return {
    edit: {
      color: theme.palette.pending.main
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "flex-end"
    },
    form: {
      "justify-content": "space-between"
    },
    mr30: {
      "margin-right": "30px"
    },
    root: {
      display: "flex",
      "flex-wrap": "no-wrap",
      padding: "20px"
    },
    flex: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    w30: {
      width: "30%"
    },
    w45: {
      width: "45%"
    },
    w90: {
      width: "90%"
    }
  };
});
var billingInfoSchema = Yup.object().shape({
  name: Yup.string().required(),
  address: Yup.string().required(),
  vat_number: Yup.string().required(),
  zipcode: Yup.string().required(),
  town: Yup.string().required(),
  province: Yup.string().required()
});

var BillingInfo = function BillingInfo(props) {
  var classes = useStyles();
  var info = props.info,
      translation = props.translation,
      editInfo = props.editInfo;

  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];
  /* ----Edit */


  var handleEdit = function handleEdit() {
    return setMode("edit");
  };

  var handleClose = function handleClose() {
    return setMode("view");
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Button, {
    "data-cy": "edit-info",
    key: "edit-info",
    className: classes.edit,
    color: "default",
    variant: "text",
    onClick: handleEdit
  }, /*#__PURE__*/React.createElement(Create, null))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.form
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: info || {},
    validationSchema: billingInfoSchema,
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;
      editInfo(values);
      handleClose();
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "billing-info",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.flex
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Field, {
          label: translation ? translation.inputs.legal_entity : "Is Legal Entity ?",
          name: "isLegalEntity",
          key: "isLegalEntity",
          "data-cy": "isLegalEntity",
          component: CheckboxWithLabel,
          color: "primary",
          disabled: mode === "view"
        }),
        label: translation ? translation.inputs.legal_entity : "Is Legal Entity ?"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "name",
        key: "name",
        className: [classes.mr30, classes.w45].join(" "),
        fullWidth: true,
        label: translation ? translation.inputs.name : "Legal Entity Name/Name",
        placeholder: translation ? translation.inputs.name : "Legal Entity Name/Name",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      }), !values.isLegalEntity && [/*#__PURE__*/React.createElement(Field, {
        name: "firstSurname",
        key: "firstSurname",
        className: [classes.mr30, classes.w45].join(" "),
        fullWidth: true,
        label: "Primer apellido",
        placeholder: "Primer apellido",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "lastSurname",
        key: "lastSurname",
        className: [classes.mr30, classes.w45].join(" "),
        fullWidth: true,
        label: "Segundo apellido",
        placeholder: "Segundo apellido",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      })], /*#__PURE__*/React.createElement(Field, {
        name: "vat_number",
        key: "vat_number",
        className: [classes.mr30, classes.w45].join(" "),
        label: translation ? translation.inputs.vat_number : "Vat number",
        placeholder: translation ? translation.inputs.vat_number : "Vat number",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12
      }, /*#__PURE__*/React.createElement(Field, {
        name: "address",
        key: "address",
        fullWidth: true,
        className: [classes.mr30, classes.w0].join(" "),
        label: translation ? translation.inputs.address : "Address",
        placeholder: translation ? translation.inputs.address : "Address",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.flex
      }, /*#__PURE__*/React.createElement(Field, {
        name: "zipcode",
        key: "zipcode",
        className: [classes.mr30, classes.w30].join(" "),
        label: translation ? translation.inputs.zipcode : "Postal Code",
        placeholder: translation ? translation.inputs.zipcode : "Postal Code",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "town",
        key: "town",
        className: [classes.mr30, classes.w30].join(" "),
        label: translation ? translation.inputs.town : "City",
        placeholder: translation ? translation.inputs.town : "City",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      }), /*#__PURE__*/React.createElement(Field, {
        name: "province",
        key: "province",
        className: [classes.mr30, classes.w30].join(" "),
        label: translation ? translation.inputs.province : "Province",
        placeholder: translation ? translation.inputs.province : "Province",
        component: TextField,
        margin: "normal",
        variant: "outlined",
        disabled: mode === "view"
      }))), mode !== "view" && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        "data-cy": "cancel",
        type: "button",
        key: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: handleClose
      }, translation ? translation.buttons.cancel : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        "data-cy": "submit",
        size: "medium",
        key: "submit",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, translation ? translation.buttons.save : "Save"))));
    }
  }))];
};

export { BillingInfo };